import { z } from 'zod';
import { MessageIdSchema } from '../ids.ts';

export const FEEDBACK_COMMENT_MAX_LENGTH = 2000;

export const FeedbackRatingSchema = z.enum(['up', 'down']);
export type FeedbackRating = z.infer<typeof FeedbackRatingSchema>;

export const PutFeedbackRequestSchema = z.object({
  rating: FeedbackRatingSchema,
  comment: z.string().max(FEEDBACK_COMMENT_MAX_LENGTH).nullable().optional(),
});
export type PutFeedbackRequest = z.infer<typeof PutFeedbackRequestSchema>;

export const MessageFeedbackSchema = z.object({
  object: z.literal('message_feedback'),
  message_id: MessageIdSchema,
  rating: FeedbackRatingSchema,
  comment: z.string().nullable(),
  updated_at: z.string(),
});
export type MessageFeedback = z.infer<typeof MessageFeedbackSchema>;
